/**
 * A list of organizations to pick one from, as a column of buttons.
 *
 * Two pickers share it: the sign-in form's, shown when one address and
 * password match accounts at several organizations, and the platform
 * administrator's, shown after sign-in and again from the account menu. They
 * are meant to look the same, and one component is what keeps them so.
 */
export interface OrganizationChoice {
  /** Null is platform administration, which has no slug either. */
  id: string | null;
  name: string;
  slug: string | null;
  /** Why the choice cannot be taken, shown in place of the slug. */
  note?: string;
}

export function OrganizationChoices({
  choices,
  disabled,
  onChoose,
}: {
  choices: readonly OrganizationChoice[];
  /** While a choice is being acted on, none can be made. */
  disabled: boolean;
  onChoose: (id: string | null) => void;
}) {
  return (
    <div className="grid gap-2">
      {choices.map((choice) => (
        <button
          key={choice.id ?? 'platform'}
          type="button"
          className="btn justify-between"
          disabled={disabled || choice.note !== undefined}
          onClick={() => onChoose(choice.id)}
        >
          <span>{choice.name}</span>
          {choice.note ? (
            <span className="text-xs text-ink-faint">{choice.note}</span>
          ) : choice.slug ? (
            <span className="font-mono text-xs text-ink-faint">{choice.slug}</span>
          ) : null}
        </button>
      ))}
    </div>
  );
}
